// extracted by mini-css-extract-plugin
export default {"root":"RGQSC","content":"bg5A5","noDataPic":"BxujM","title":"GFynm"};